<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col cols="3">
					<b-form-select v-model="departmentId" name="departmentId">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt" :value="selectOption.id">{{ selectOption.name }}</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col cols="2">
					<date-picker v-model="fromDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY"/>
				</b-col>
				<b-col cols="2">
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')" value-type="format" format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<b-form-input v-model="itemName" :placeholder="$t('goods.name')"/>
				</b-col>
				<b-col cols="2">
					<b-checkbox v-model="withSum" style="display: inline-block" class="mr-3" switch>Сумма</b-checkbox>
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-1"/>
					<b-button @click="print" variant="outline-dark" class="fa fa-print mr-1"/>
					<b-button @click="pricePrint" variant="outline-dark"><b>Сум</b></b-button>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						v-model="group"
						:multiple="true"
						:options="groups"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						class="multiselect-pricing"
						:placeholder="$t('goods.create.select-group')"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="true"
						v-model="category"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						:options="categorys"
						class="multiselect-pricing"
						:placeholder="$t('goods.create.category')"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						v-model="group1"
						:multiple="true"
						:options="groups"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						id="danger-multiselect"
						placeholder="Кроме группы"
						class="multiselect-pricing danger-multiselect"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="true"
						v-model="category1"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						:options="categorys1"
						class="multiselect-pricing danger-multiselect"
						placeholder="Кроме категории"
					/>
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body>
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px"><b>Central Asia Megastar</b></div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>Остатки по дням с {{ fromDate ? fromDate : '________' }} по {{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right"></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ departmentId ? depName : '__________________' }}</b>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col class="table-responsive">
					<table class="b-table table-hover table-bordered" style="line-height: 1.2; font-family: 'Open Sans'; color: #000; width: 100%">
						<thead v-if="items.length > 0" style="width: 100%">
						<tr>
							<th :colspan="withSum ? '6' : '5'"></th>
							<th v-for="i in items[0].dateByRemaining" class="text-center" style="font-size: 10px">{{ i.day }}</th>
						</tr>
						<tr>
							<th class="text-center" style="font-size: 13px; width: 20px">№</th>
							<th class="text-center" style="font-size: 13px">Спецкод</th>
							<th class="text-center" style="font-size: 13px">Шк</th>
							<th class="text-center" style="font-size: 13px">Наименование</th>
							<th class="text-center" style="font-size: 13px">Цена</th>
							<th v-if="withSum" class="text-center" style="font-size: 13px">Сумма</th>
							<th v-for="t in items[0].dateByRemaining" class="text-center" style="font-size: 11px">{{ t.date }}</th>
						</tr>
						</thead>
						<tbody v-if="!loading">
						<tr v-for="(item, index) in items" :key="`items-${index}`">
							<td class="text-center" style="font-size: 13px">{{ index + 1 }}</td>
							<td class="text-center" style="font-size: 13px">{{ item.barcode }}</td>
							<td class="text-center" style="font-size: 13px">
								<span>{{ item.multiBarcode[0] }}</span>
							</td>
							<td class="text-left" style="font-size: 13px">{{ item.itemName }}</td>
							<td class="text-center" style="font-size: 11px">{{ item.price }}</td>
							<td v-if="withSum" class="text-center" style="font-size: 11px">{{ item.dateByRemaining[0].remaining * item.price }}</td>
							<td v-for="tmp in item.dateByRemaining" style="font-size: 13px; padding: 0; margin: 0">
								<table style="width: 100%; border: none; padding: 0; margin: 0">
									<tr style="border: none">
										<td style="border: none">
											{{ tmp.remaining }}
										</td>
										<td style="border: none">

										</td>
									</tr>
								</table>
							</td>
						</tr>
						<tr v-if="items.length > 0" style="font-size: 12px">
							<td colspan="5" class="text-center"><b>Итого:</b></td>
							<td v-if="withSum" class="text-center">{{ sumSum }}</td>
							<td :colspan="items[0].dateByRemaining.length" class="text-center">{{ sumRemaining }}</td>
						</tr>
						</tbody>
						<tbody v-else>
						<tr>
							<td class="text-center" colspan="5">
								<b-spinner small class="mr-2"/><strong>Loading...</strong>
							</td>
						</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
		</b-card-body>
	</b-card>
</template>

<script>
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";
import Multiselect from "vue-multiselect";
import ReferencesService from "../../../services/references.sevice";

export default {
	name: "index",
	components: {Multiselect},
	data() {
		return {
			items: [],
			departments: [],
			itemName: '',
			allGroup: false,
			allCategory: false,
			group: null,
			group1: null,
			category: null,
			category1: null,
			groups: [],
			categorys: [],
			categorys1: [],
			groupIds: [],
			groupNots: [],
			categoryIds: [],
			subGroupNots: [],
			departmentId: null,
			fromDate: null,
			toDate: null,
			withSum: false,
			loading: false
		}
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		sumSum() {
			let sum = 0
			this.items.forEach(t => {
				if (t.dateByRemaining)
					if (t.dateByRemaining.length > 0)
						sum+=t.dateByRemaining[0].remaining * t.price
			})
			return sum
		},
		sumRemaining() {
			let sum = 0
			this.items.forEach(t => {
				if (t.dateByRemaining)
					if (t.dateByRemaining.length > 0)
						sum+=t.dateByRemaining[0].remaining
			})
			return sum
		}
	},
	watch: {
		'group': {
			handler(g) {
				this.groupIds = []
				g.filter(t => this.groupIds.push(t.id))
				if (this.groupIds.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupIds).then(res => {
						this.categorys = res.data
					})
				} else {
					this.categorys = []
				}
				this.category = null
			}
		},
		'category': {
			handler(c) {
				this.categoryIds = []
				c.filter(t => this.categoryIds.push(t.id))
			}
		},
		'group1': {
			handler(g) {
				this.groupNots = []
				g.filter(t => this.groupNots.push(t.id))
				if (this.groupNots.length > 0) {
					ReferencesService.getCategorysByGroupIds(this.groupNots).then(res => {
						this.categorys1 = res.data
					})
				} else {
					this.categorys1 = []
				}
				this.category1 = null
			}
		},
		'category1': {
			handler(c) {
				this.subGroupNots = []
				c.filter(t => this.subGroupNots.push(t.id))
			}
		},
		'allGroup': {
			handler(g) {
				if (g) {
					this.group = []
					this.groupIds = []
					this.groups.filter(t => this.group.push(t))
					this.groups.filter(t => this.groupIds.push(t.id))
				} else {
					this.group = null
					this.groupIds = []
				}
			}
		},
		'allCategory': {
			handler(c) {
				if (c) {
					this.category = []
					this.categoryIds = []
					this.categorys.filter(t => this.category.push(t))
					this.categorys.filter(t => this.categoryIds.push(t.id))
				} else {
					this.category = null
					this.categoryIds = []
				}
			}
		}
	},
	methods: {
		print() {
			window.print();
		},
		async pricePrint() {
			if (this.departmentId && this.fromDate && this.toDate) {
				if (this.items.length > 0) {
					await this.$store.commit('warehouse/setWarehousePricingItems', this.items);
					await this.$router.push(`/report5/warehouse-prices`)
				} else {
					this.$vs.notify({
						text: "Пока нет данных",
						color: "warning",
						icon: "close",
						position: "top-right"
					});
				}
			} else {
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
			}
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		getItems() {
			this.loading = true
			if (this.departmentId && this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					deps: this.departmentId,
					groups: this.groupIds,
					subGroups: this.categoryIds,
					groupNots: this.groupNots,
					subGroupNots: this.subGroupNots,
					value: this.itemName
				}
				ReportService.getReportItems5(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.groups = res.data
		})
		this.getDeps();
	}
}
</script>

<style scoped>
div#danger-multiselect div.multiselect__tags div.multiselect__tags-wrap span.multiselect__tag {
	background: #ff4343 !important;
}
@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
}
</style>
